import $ from "jquery";
import debug from "bows";

const log = debug("focus_tabs");

const $focus = $('.focus');
// function focusTabsInitialize() {

// }

function setActive(whichCount, doFocus, $focus) {
	let where = $focus.find('.focus-tab').eq(whichCount);
	let activeBtn = $focus.find('.focus-tabs__buttons__btn').eq(whichCount);

	$focus.find('.focus-tab--active').removeClass('focus-tab--active');
	$focus.find('.focus-tabs__buttons__btn--active').removeClass('focus-tabs__buttons__btn--active');

	where.addClass('focus-tab--active');
	activeBtn.addClass('focus-tabs__buttons__btn--active');
	if (doFocus == true) {
		where.focus();
	}

}

function setActiveTabButton(which) {

}

function focusTabsButtonsAction() {
	let $this = $(this);
	let $focus = $this.closest('.focus');
	let whichCount = $this.parent().prevAll().length;
	$focus.find('.focus-tabs__buttons__btn--active').removeClass('focus-tabs__buttons__btn--active');
	$this.addClass('focus-tabs__buttons__btn--active');
	setActive(whichCount, true, $focus);

}

function focusTabAction() {
	let $this = $(this);
	let $focus = $this.closest('.focus');
	let which = $this.closest('.focus-tab');
	let whichCount = which.prevAll().length;

	if ($this.hasClass('focus-tab__btn--active') === true) {
		$this.removeClass('focus-tab__btn--active');
		$this.next('.focus-tab__wrap').slideUp();
	} else {
		$this.addClass('focus-tab__btn--active');
		$this.next('.focus-tab__wrap').slideDown();
	}

	setActive(whichCount, false, $focus);
	which.addClass('focus-tab--active');
}

export function init() {
	if ($focus.length) {
		let $focusTabBtn = $('.focus-tab__btn');
		let $focusTabsButtonsBtn = $('.focus-tabs__buttons__btn');
		//focusTabsInitialize();
		$focusTabBtn.on('click', focusTabAction);
		$focusTabsButtonsBtn.on('click', focusTabsButtonsAction);
	}
}

export default {
	init
};
